import { FC } from 'react'

import { Card, Grid, Tag, Title } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  atsOtherAddons,
  isAtsSuscriptionAddon,
  isAtsSuscriptionAddonEnabled,
} from 'modules/ats/lib/utils/integrations'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export const OtherAddons: FC = () => {
  const { navigation } = useNavigation()
  const { integrations, apps } = subscriptionAddons
  const atsIntegrations: SubscriptionAddon[] = [...integrations, ...apps].filter(
    (addon) =>
      isAtsSuscriptionAddon(addon.id) && isAtsSuscriptionAddonEnabled(atsOtherAddons()[addon.id])
  )

  if (!atsIntegrations.length) {
    return null
  }

  const addonCards = atsIntegrations.map((x) => {
    const integrationData = atsOtherAddons()[x.id]!

    return (
      <Card
        key={x.id}
        img={integrationData.image.src}
        to={navigation.appStore.id.general.fullPath({ id: x.id })}
      >
        {x.attributes.enabled && (
          <Card.Eyebrow>
            <Tag type="neutral">{i18n.t('ats.settings.integrations.other.configured')}</Tag>
          </Card.Eyebrow>
        )}
        <Card.Title>{integrationData.title}</Card.Title>
        <Card.Description>{integrationData.description}</Card.Description>
      </Card>
    )
  })

  return (
    <>
      <Title
        variant="500"
        title={i18n.t('ats.settings.integrations.other.title')}
        description={i18n.t('ats.settings.integrations.other.description')}
      />
      <Grid variant="medium">{addonCards}</Grid>
    </>
  )
}
